// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__23Bn3","filesListContainer":"PosDisputesFiles_filesListContainer__2E_41","filesButton":"PosDisputesFiles_filesButton__6wqnk"};